var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state"},[_vm._m(0),_c('div',{staticClass:"copy"},[_vm._v(_vm._s(_vm.copy))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":require("assets/empty-state.png")}})])
}]

export { render, staticRenderFns }